import {
  Box,
  SkeletonRectangle,
  StackLayout,
} from '@leagueplatform/genesis-core';
import type { MasonryEngineNodeRendererProps } from '@leagueplatform/masonry-engine';

import React, { forwardRef } from 'react';
import { MasonryEngineNode } from '@leagueplatform/masonry-engine';
import { Props } from './types';

export const HeroBannerSkeleton = forwardRef<HTMLDivElement, Props>(
  ({ ...props }, ref) => (
    <Box
      ref={ref}
      css={{
        height: '184px',
        '@tablet': {
          height: '232px',
        },
        '@mobileLandscape': {
          height: '232px',
        },
        '@laptop': {
          height: '351px',
        },
        '@desktop': {
          height: '351px',
        },
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <StackLayout
        css={{
          position: 'absolute',
          top: 0,
          insetInlineStart: 0,
          insetInlineEnd: 0,
          height: 'auto',
          paddingBlock: '$twoAndHalf',
          paddingInline: '$three',
          '@mobile': {
            paddingBlock: '$oneAndHalf',
            paddingInline: '$oneAndHalf',
          },
          backgroundColor: '$decorativeBrandPrimaryPastel',
        }}
      >
        <SkeletonRectangle
          height={{
            '@initial': '136px',
            '@laptop': '255px',
            '@desktop': '255px',
          }}
        />
      </StackLayout>
    </Box>
  ),
);

export type HeroBannerSkeletonWSNode = MasonryEngineNode<
  'loadingHeroBanner',
  Props
>;

export const HeroBannerWSSkeletonRenderer = ({
  rootElementRef,
  ...props
}: MasonryEngineNodeRendererProps<HeroBannerSkeletonWSNode>) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <HeroBannerSkeleton ref={rootElementRef} {...props} />
);
